import React, { useState, useEffect } from 'react';
import { useNavigate, Link,useLocation} from 'react-router-dom';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import myLogoOnly from '../assets/img/logo-only.png';
import { Typography, Modal, 
} from '@mui/material';
import Box from '@mui/material/Box';
import VirtualizedSelect from 'react-virtualized-select';
import AxiosFetchData from './AxiosFetchData';
import ResponseDialog from '../components/ResponseDialog';
import { setMilliseconds } from 'date-fns';
import { apiUrl } from './UrlParam';
import UserDialog from '../components/UserDialog';
//import Roles from '../../../backend/models/roles.model';
import {
  LayoutDashboard,
  Users,
  ShoppingBag,
  BarChart3,
  Settings,
  FileText,
  Wallet,
  Bell
} from 'lucide-react';
 

//import { requestFCMToken } from '../utils/firebase';
 
export default function Sidebar( { isOpen, onClose }) {
  const [name, setName] = useState('');
  const [userName, setUserName] = useState('');
  const [role, setRole] = useState('');
  const [uid, setUid] = useState('');
  const [token, setToken] = useState('');
  const [expire, setExpire] = useState('');
  const [idStatus, setIdStatus] = useState('');
  const [roleList, setRoleList] = useState('');
  const [selectedRoles, setSelectedRoles] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmStatusOpen, setConfirmStatusOpen] = useState('');
  const [message, setmessage] = useState('');
  const [msg, setmsg] = useState('');
  const location = useLocation();
  
  const [rows, setRows] = useState([]);
  const Navigate = useNavigate()
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get('ReturnUrl');
  const lastReturnUrl = urlParams.toString().split('ReturnUrl')
  //console.log(lastReturnUrl[lastReturnUrl.length - 1].replace("%3D",'').replace('=',''))
  useEffect(() => {
     GetUser();
    
  }, []);

    const GetUser = async () => {
      try{
       const decoded = jwt_decode(localStorage.getItem('token'));
       setRole(decoded.role)
       setIdStatus(decoded.userID)
      await GetMenu(decoded.role);
      
     }catch(err){
        console.log(err)
  
      }
  }

  const handleProfile = async (id) => {
    setConfirmStatusOpen(true)
  }

  const GetMenu = async (roleId) => {
    var response = await AxiosFetchData.get(`GetMenu/${roleId}`).refreshToken(Navigate)
    if(response.data.length > 0){
        setRows(response.data);
    }
  }
   
return (
<>
{isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-20 lg:hidden"
          onClick={onClose}
        />
      )}
      <aside className={`w-96 bg-slate-900 text-white h-screen fixed left-0 top-0 overflow-y-auto transition-transform duration-300 z-30 ${
        isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
      }`}>
        <div className="p-1">
        <div className="flex items-center space-x-2 mb-8">
         
          <Link to="#" className="logo"><img src={myLogoOnly} alt="" width='189' /></Link>
        </div>
          
        <nav className="space-y-1">
          {rows.map((item,index) => {
            //console.log(location.pathname)
           // console.log(lastReturnUrl[lastReturnUrl.length - 1].replace("%3D",'').replace('=',''))
           // console.log(lastReturnUrl[lastReturnUrl.length - 1].replace("%3D",'').replace('=',''))
           // console.log(item.route.includes(lastReturnUrl[lastReturnUrl.length - 1].replace("%3D",'').replace('=','').split('%2F')[0].trim()))
            const isActive = (location.pathname == item.route) || ("/" + lastReturnUrl[lastReturnUrl.length - 1].replace("%3D",'').replace('=','')  == item.route );
              
            return (
                 <Link to={item.route}   key={index}>
                    <span 
                      className={`w-full text-xl flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${
                  isActive
                    ? 'bg-gradient-to-r from-cyan-500 to-blue-500 text-white shadow-lg shadow-cyan-500/30'
                    : 'text-slate-400 hover:bg-slate-800 hover:text-white'
                }`}>{item.name}</span> 
                </Link>
            //   <button
            //     key={item.id}
            //  //   onClick={() => handleItemClick(item.id)}
            //     className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${
            //       isActive
            //         ? 'bg-gradient-to-r from-cyan-500 to-blue-500 text-white shadow-lg shadow-cyan-500/30'
            //         : 'text-slate-400 hover:bg-slate-800 hover:text-white'
            //     }`}
            //   >
              
            //     <span className="font-medium">{item.name}</span>
            //   </button>
            );
          })}
          {role.toUpperCase() == 'SUPERADMIN' && (
            <Link to="/RolesPolicies" >
               <span  className={`w-full text-xl flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${
                  location.pathname == "/RolesPolicies"
                    ? 'bg-gradient-to-r from-cyan-500 to-blue-500 text-white shadow-lg shadow-cyan-500/30'
                    : 'text-slate-400 hover:bg-slate-800 hover:text-white'
                }`}>Group Role Policies</span> 
          </Link>
          )}
        </nav>
      </div>
    </aside>

{/* {isOpen && (
      <div 
          className="fixed inset-0 bg-black  opacity-50 z-40 lg:hidden"
          onClick={onClose}
      />
      )} */}
      
      {/* Sidebar */}
      {/* <div className={`
        h-screen fixed left-0 top-0 w-96 bg-gray-50 shadow-xl transform transition-transform duration-300 ease-in-out z-50
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        lg:translate-x-0 lg:static lg:shadow-none lg:border-r lg:border-gray-200
      `}>
        <div className='item-center bg-[#71717B] py-1'>
            <Link to="#" className="logo"><img src={myLogoOnly} alt="" width='189' /></Link>
        </div>
        
        <div className="flex items-center justify-between pl-3 border-b border-gray-200 bg-grey lg:border-none">
          <h1 className="text-xl font-bold text-gray-800">
          {role != "SL" && (
             <p>hi, <a onClick={handleProfile}><i></i> {userName}</a></p>
          )}
      
          {role == "SL" && (
              <p>Hi, <i></i> {userName} </p>
          )}
 
          </h1>
          <button 
            onClick={onClose}
            className="p-1 rounded-lg hover:bg-gray-100 lg:hidden"
          >
            <X size={20} />
          </button>
        </div>
        
        <nav className="mt-0 px-4 bg-gray">
          <div className='overflow-y-auto h-screen' >
          {rows.map((item, index) => (
            <Link to={item.route}  className={`
                flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-all duration-200
                 
              `} key={index}>
              <i key={index} className="fa fa-gear"></i> <span className="font-medium  text-black hover:text-white">{item.name}</span> 
           </Link>
           
          ))}
          {role.toUpperCase() == 'SUPERADMIN' && (
            <Link to="/RolesPolicies" className={`
                flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-all duration-200
               
              `}>
               <i className="fa fa-gear"></i><span className="font-medium  text-black hover:text-white">Group Role Policies</span> 
          </Link>
          )}
         </div>
        </nav>
        
        
      </div> */}

      <ResponseDialog message={message} setmessage={setmessage}/>
      <UserDialog showDialog={confirmStatusOpen}
        handleClose={() => setConfirmStatusOpen(false)}
        idstatus ={idStatus}
        handleName={(username) => setUserName(username)}
        handleMessage={(msg) => setmsg(msg)}></UserDialog>
</>


)





}